import { strictParseInt } from '../../lib/number.no-deps'
import type { Nominal } from '../../lib/typeHelpers.no-deps'

/**
 * This file should be kept in line with portal/apps/src/Data/Flow/LoopPath.elm
 */

/**
 * LoopPath is a hash made up of ids that represent the nesting of loop elements
 */
export type LoopPath = Nominal<string, 'LoopPath'>
export type LoopId = { unitId: number }
export type LoopPathIds = LoopId[]

export function toLoopPath(loopPathIds: LoopPathIds): LoopPath {
    return loopPathIds.map((i) => `u${i.unitId}`).join('-') as LoopPath
}

export function fromLoopPath(loopPath: LoopPath): LoopPathIds {
    if (loopPath === '') return []

    return loopPath.split('-').map((part) => {
        // If in the future we loop of over new things, then this needs to be updated
        if (!part.startsWith('u')) throw new Error(`Unrecognized loop path prefix: ${part}`)

        // Otherwise, parse the id of the unit as an integer
        const unitId = strictParseInt(part.slice(1))
        if (unitId == null) throw new Error(`Could not parse loop path id: ${part}`)

        return { unitId }
    })
}
